import styled from 'styled-components'
import arrowRightBlack from '../../../../static/steam-img/arrows/ArrowLong_Right_Black.svg'
import arrowRightWhite from '../../../../static/steam-img/arrows/ArrowLong_Right_White.svg'

export const SubscribeContainer = styled.div`
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.3s ease-in-out;

  &.SubscribeModal--Visible {
    transform: translateY(0%);
    opacity: 1;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    background: url('https://images.ctfassets.net/5965pury2lcm/3GJn1WAJqb6JBLO5eiVA1E/8e19493087b9653a6474308069ae368d/transparent-macs.svg')
      no-repeat;
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
  }

  &:after {
    content: '';
    position: absolute;
    top: -81px;
    left: 50%;
    object-fit: cover;
    transform: translateX(-50%);
    background: url('https://images.ctfassets.net/5965pury2lcm/1kQc2KAWdjN3yzdAbGYRaU/129a840ec2799f10935b0af152bcce14/blog-popup-robot.png')
      no-repeat;
    background-position: center;
    background-size: cover;
    width: 115px;
    height: 128px;
  }
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 64px;
  max-width: 500px;
  min-height: 423px;
  background: ${p => p.theme.webMktPalette.orange[50]};
  padding: 46px 40px 40px;
  box-sizing: border-box;

  .SubscribeModal__Headline,
  .SubscribeModal__Subheadline {
    margin-bottom: 0;
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
  }

  .SubscribeModal__Headline {
    margin-top: 17px;
  }

  .SubscribeModal__Subheadline {
    margin-top: 8px;
  }

  &.formSubmitted {
    display: flex;
    align-items: center;

    form {
      display: none !important;
    }

    .SubscribeModal__Headline,
    .SubscribeModal__Subheadline {
      display: none;
    }
    .SubscribeModal__Confirm {
      display: block;
      h3,
      .SubscribeModal__SuccessMessage {
        text-align: center;
        color: ${p => p.theme.webMktPalette.text.primaryWhite};
      }

      h3 {
        margin: 0;
      }

      .SubscribeModal__SuccessMessage {
        margin: 8px 0 0;
      }
    }
  }

  ${p => p.theme.breakpoints.down('md')} {
    padding: 47px 24px 40px;
    min-height: 353px;
    max-width: 480px;
  }

  .SubscribeModal__Confirm {
    > h4 {
      color: ${p => p.theme.webMktPalette.text.primaryWhite};
    }

    display: none;
  }

  @media screen and (max-width: 564px) {
    left: 0;
  }

  .SubscribeModal__Close-Icon {
    position: absolute;
    top: 22px;
    right: 24px;
    width: 18px;
    height: 18px;
    pointer-events: auto;
    cursor: pointer;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }

  // FORM STYLING
  form.mktoForm {
    padding: 20px 0 0 !important;
    flex-direction: column;
  }
  .mktoFormCol {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .mktoForm .mktoFormCol,
  .mktoForm .mktoFieldWrap {
    max-width: unset !important;
  }

  .mktoForm input[type='checkbox'] + label {
    padding-left: 26px;
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
    font-size: 10px;
    font-weight: normal;
    letter-spacing: 0px;
    line-height: 16px;

    a {
      color: inherit;
      padding: 0;
      &:hover {
        text-decoration: underline;
        font-weight: 700;
      }
    }
  }

  .mktoLogicalField.mktoCheckboxList.mktoHasWidth {
    padding: 0;
    label {
      box-sizing: border-box;
    }
  }

  #LblEmail {
    display: none;
  }

  #Email {
    color: rgb(89, 90, 92);
    height: 48px !important;
  }

  .mktoFormRow:nth-of-type(3) {
    #LblCountry {
      font-family: 'Inter', sans-serif !important;
      font-weight: 400 !important;
      color: ${p => p.theme.webMktPalette.text.primaryWhite};

      .mktoAsterix {
        color: ${p => p.theme.webMktPalette.text.primaryWhite};
      }
    }
    #Country {
      height: 56px !important;
    }
  }

  .mktoFormRow:nth-of-type(2) {
    width: 100%;
  }

  .mktoButtonWrap.mktoSimple {
    padding: 0 !important;
    margin: 0px !important;
  }

  .mktoErrorMsg {
    color: ${p => p.theme.webMktPalette.text.primaryWhite} !important;
  }

  .mktoButton.mktoButton.mktoButton.mktoButton.mktoButton.mktoButton {
    font-family: 'Inter', sans-serif !important;
    font-size: 16px !important;
    font-weight: bold !important;
    height: auto !important;
    letter-spacing: 0px !important;
    line-height: 24px !important;
    margin-top: 0 !important;
    position: relative;
    text-transform: none !important;
    background: ${p => p.theme.webMktPalette.button.secondaryBlack} !important;
    border-radius: 0 !important;
    padding: 12px 57px 12px 16px !important;
    transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: ${p => p.theme.webMktPalette.button.secondaryWhite} !important;
      color: ${p => p.theme.webMktPalette.text.actionBlack} !important;
      &:after {
        background-image: url(${arrowRightBlack});
      }
    }

    &:after {
      content: '';
      position: absolute;
      top: 51%;
      transform: translateY(-50%);
      right: 20px;
      width: 22px;
      height: 22px;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url(${arrowRightWhite});
    }
  }

  @media screen and (max-width: 480px) {
    .mktoForm .mktoFormRow {
      flex-direction: row !important;
    }
  }
`
